
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable 
      max-width="800px"
      transition="dialog-transition"
      
    >
      <v-card :outlined="$vuetify.theme.isDark">
        <card-loading-transparent class="pt-3" v-if="loading"></card-loading-transparent>
        
        <template v-if="!loading && one_company && one_company.id">
          <v-card-title primary-title>
            Uso do cliente
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-4">
            <!-- {{ one_company }} -->
            <div style="border: none 2px #ddd; border-radius: 12px;" class="px-1 mb-4">
              <div>
                <span>
                  Nome: 
                </span>
                <b>{{ one_company.name }}</b>
              </div>
              <div>
                <span>
                  Razão social: 
                </span>
                <b>{{ one_company.corporate_name }}</b>
              </div>
              <div>
                <span>
                  Criado no sistema: 
                </span>
                <b>{{ $moment(one_company.created_at).format('DD/MM/YYYY, HH:mm') }}</b>
              </div>
              <div>
                <span>
                  Status: 
                </span>
                <b>{{ one_company.status }}</b>
              </div>
              <div>
                <span>
                  E-mail principal: 
                </span>
                <b>{{ one_company.main_email }}</b>
              </div>

              <div>
                <span>
                  E-mail secundário: 
                </span>
                <b>{{ one_company.second_email }}</b>
              </div>
              <template v-if="['on_trial', 'trial_expired'].includes(one_company.status) && one_company.json_attributes.trial">
                <div>
                  <span>
                    Duração em dias: 
                  </span>
                  <b>{{ one_company.json_attributes.trial.days_duration }}</b>
                </div>
                <div>
                  <span>
                    Início | Fim dos testes: 
                  </span>
                  <b>
                    {{ $moment(one_company.json_attributes.trial.start_date).format('DD/MM/YYYY') }} |
                    {{ $moment(one_company.json_attributes.trial.end_date).format('DD/MM/YYYY') }}
                  </b>
                </div>
                <div>
                  <span>
                    Campanha: 
                  </span>
                  <b>{{ one_company.json_attributes.trial.campaign_reference }}</b>
                </div>
              </template>
            </div>
            <div v-if="Object.keys(one_company.data).length">

              <div style="border: solid 2px #ddd; border-radius: 12px;" class="pa-3">
                <v-progress-linear v-if="!chart_ready" color="secondary" :indeterminate="true"></v-progress-linear>
                <line-chart v-if="chart_ready" :chart-data="ChartData" :options="ChartOptions" style="height: 400px" class="mt-3"></line-chart>
              </div>

              <v-timeline align-top :dense="true" :loading='true'>
                <v-slide-x-reverse-transition group hide-on-leave>
                  <v-timeline-item fill-dot small
                    v-for="(month) in Object.keys(one_company.data).sort().reverse()" :key="month"
                    :color="'secondary'"
                    :icon="'mdi-circle'"
                  >
                    <v-card :outlined="$vuetify.theme.isDark">
                      
                      <v-card-text class="py-1">
                        <!-- <p></p> -->
                        <div>
                          <b>Mês/Ano: </b>
                          <span>{{ $moment(month).add(12, 'h').format('MMMM/YYYY')}} </span>
                        </div>
                        <div>
                          <b> Uso: </b>
                        </div>
                        
                        <div v-for="(val, k) in one_company.data[month]" :key="val+k+month" class="ml-3">
                          <b>{{ k }}: </b>
                          <span>{{ val }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-slide-x-reverse-transition>
              </v-timeline>

              

            </div>

            <div v-if="!Object.keys(one_company.data).length">
              <v-alert type="info" color='concluded' :value="true">
                Sem nenhuma uso no período de 12 meses
              </v-alert>
            </div>
          </v-card-text>
        </template>
        <v-alert class="ma-0" v-if="!loading && (!one_company || !one_company.id)" type="error" :value="true">
          Houve um erro.
        </v-alert>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';
import LineChart from '../../../components/charts/LineChart.vue';

export default {
  name: 'DialogClientUsage',
  //mixins: [ validations ],
  components: {
    LineChart
    //ComponentName: () => import(''),
  },
  data() {
    return {
      dialog: true,

      one_company: null,

      loading: false,

      chart_ready: false,

      ChartData:{
        datasets: [
          // {
          //   //bags
          //   data: [],
          //   //has N colors, fusion custom computed
          //   backgroundColor: [], 
          //   borderColor: [],
          //   borderWidth: 2,
          //   hoverBackgroundColor: [],
          //   label: 'Venda',
          //   aux: 'Compras',
          //   aux2: '',
          // },
        ],
        // These labels appear in the legend and in the tooltips when hovering different arcs
        // labels: ['2019-09-01', '2019-10-01', '2019-11-01', '2020-03-01'],
      },
      ChartOptions:{
        fill: false,
        responsive: true,
        maintainAspectRatio: false,
        
        scales: {
          xAxes: [{
            type: 'time',
            display: true,
            // distribution: 'series',
            time:{
              unit: 'month',
              tooltipFormat: 'DD-MM-YYYY',
              displayFormats: {
                month: 'MM/YYYY',
                day: 'DD/MM/YYYY',
                week: 'DD/MM/YYYY'

              }},
            scaleLabel: {
              display: true,
              labelString: "Data",
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
            display: true,
            scaleLabel: {
              display: true,
            }
          }]
        },
        legend:{
          display: true, 
          position: 'bottom',
          labels: {
            boxWidth: 15
          }
        },
        tooltips: {
          enabled: true,
          mode: 'nearest',
        },
        plugins: {
          // zoom: {
          //   pan: { enabled: true, mode: 'xy', speed: 10, threshold: 10,   },
          //   zoom: { enabled: true, mode: 'xy', },
	        // },
          datalabels: {
            display: function(ctx){
              // console.log({ctx});
              
              return  false
            },
            align: 'start',
            anchor: 'end',
            font: {
              weight: 'bold',
              size: 11
            },
            formatter: function(value, context) {
              return context.dataset.label + ' - ' + context.dataset.data[context.dataIndex].y
            }
          }
        }
      },
    }
  },
  methods: {
    showCompany(id){
      this.loading = true
      this.loadingText = 'Carregando'
      Api.Company.showUsage(id).then(r=>r.data).then(comp=>{
        this.one_company = {...comp}
        this.loadChart(this.one_company.chart)
      }).catch(err=>{
        console.log({err});
      }).finally(()=>{
        this.loading = false
      })
    },
    loadChart(dash_data) {
      if (!dash_data){
        
      
      } else {
        this.ChartData.datasets = []
        this.chart_ready = false
        this.loading = true
        for (let key in dash_data){
          let d_set = {
            label: key,
            fill:false,
            data: []
          }

          let months = Object.keys(dash_data[key]).sort()
          months.forEach(month => {
            let point = {
              // x: new Date(Object.keys(el)[0]+'T12:00:00').toLocaleDateString('pt-BR'),
              x: this.$moment(month).add(12, 'h'),
              y: dash_data[key][month]
            }
            d_set.data.push(point)
          })

          this.ChartData.datasets.push(d_set)
        }
      }

      this.setChartOptions()
    
      setTimeout(() => {
        this.chart_ready = true
        this.loading = false
      }, 500);
    },
    setChartOptions(){
      this.ChartOptions.scales.xAxes[0].time.unit = 'month'

    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    this.showCompany(this.$route.params.id);
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
    
      } else if (nv == false){
        this.$router.go(-1)
      }
    }
  },
}
</script>

<style scoped>

</style>